import CreatableSelect from "react-select/creatable";
import { useUserViewModel } from "../../viewmodels/user/userViewModel";

interface Props {
  value: string;
  onChange: (value: string) => void;
}

const TechnicianAsyncSelect = ({ value, onChange }: Props) => {
  const { users } = useUserViewModel();

  return (
    <CreatableSelect
      isClearable
      isSearchable
      placeholder="Select or type technician"
      value={
        value
          ? {
              value,
              label: value,
            }
          : null
      }
      options={users.map((u: any) => ({
        value: `${u.firstName} ${u.lastName}`,
        label: `${u.firstName} ${u.lastName}`,
      }))}
      onChange={(selected: any) => onChange(selected?.value || "")}
      onCreateOption={(inputValue) => onChange(inputValue)}
    />
  );
};

export default TechnicianAsyncSelect;